import { i18n, i18nNavigator, setLanguage } from 'utils/translate';
import Logger from './Managers/Logger';
import Profiler from './Managers/Profiler';
import Widget from './Managers/Widget';
import Ajax from './Managers/Ajax';
import Hash from './Managers/Hash';

const Application = function () {
    this.init();
};
Application.prototype.version = '1';
Application.prototype.widgets = null;
Application.prototype.i18n = i18n;
Application.prototype.i18nBIS = i18nNavigator;
Application.prototype.init = async function () {
    this.logger = new Logger();
    this.profiler = new Profiler();
    this.widgets = new Widget();
    this.ajax = new Ajax();
    this.hash = new Hash();

    await setLanguage(trovitData.localeISO3166, navigator.language);
};

Application.prototype.start = function () {
    this.widgets.initAll(this);
};

Application.prototype.log = function (eDesc, eType) {
    this.logger.add(eDesc, eType);
};

export default Application;
